var map = {
	"./App": "M93x",
	"./App.vue": "M93x",
	"./assets/facebook.png": "p8ve",
	"./assets/font/Montserrat-Black.ttf": "1YRD",
	"./assets/font/TUV-Montserrat-Bold.ttf": "9Jux",
	"./assets/font/UTM-Erie-Black.ttf": "lWoS",
	"./assets/font/UTM-Mabella.ttf": "o3wb",
	"./assets/font/font.css": "NrZ4",
	"./assets/icon-close.png": "p6I1",
	"./assets/jump/bgi-btn.png": "/xku",
	"./assets/jump/bgi-dialog.png": "BDdE",
	"./assets/jump/bgi-form.png": "rUIr",
	"./assets/jump/bgi-h5.jpg": "ugzP",
	"./assets/jump/bgi-pc.jpg": "Ddo7",
	"./assets/jump/bgi-tag-left-active.png": "OcVW",
	"./assets/jump/bgi-tag-left.png": "DETP",
	"./assets/jump/bgi-tag-right-active.png": "RZlV",
	"./assets/jump/bgi-tag-right.png": "FLOZ",
	"./assets/jump/eye-close.png": "Mrk/",
	"./assets/jump/eye-open.png": "06rf",
	"./assets/jump/icon-close.png": "TMsi",
	"./assets/jump/icon-code.png": "+4ys",
	"./assets/jump/icon-email.png": "rpZf",
	"./assets/jump/icon-password.png": "eHm3",
	"./assets/jump/icon-phone.png": "0CH/",
	"./assets/jump/icon-username.png": "WYE9",
	"./assets/jump/swiper-left.png": "Lf5e",
	"./assets/jump/swiper/swiper-1.jpg": "+uCx",
	"./assets/jump/swiper/swiper-2.jpg": "pcqw",
	"./assets/jump/swiper/swiper-3.jpg": "bWU6",
	"./assets/jump/swiper/swiper-4.jpg": "s7oN",
	"./assets/jump/title.png": "sfFk",
	"./assets/ldp/bg-h5.png": "dym9",
	"./assets/ldp/bg.png": "3Y69",
	"./assets/ldp/bg1.png": "+8U3",
	"./assets/ldp/bg2.png": "1q6J",
	"./assets/ldp/bg3.png": "QUaD",
	"./assets/ldp/bg4.png": "Yfg1",
	"./assets/ldp/closebtn.png": "HODe",
	"./assets/ldp/end-title.png": "WoHD",
	"./assets/ldp/eye-close.png": "8aZL",
	"./assets/ldp/eye-open.png": "pj+X",
	"./assets/ldp/form/icon-code.png": "EvlP",
	"./assets/ldp/form/icon-passwd.png": "UjSj",
	"./assets/ldp/form/icon-user.png": "Df5e",
	"./assets/ldp/form/login-1.png": "mzRT",
	"./assets/ldp/form/login-2.png": "b6rf",
	"./assets/ldp/form/register-1.png": "yLlx",
	"./assets/ldp/form/register-2.png": "QX4n",
	"./assets/ldp/game-1.png": "lheM",
	"./assets/ldp/game-2.png": "TyAq",
	"./assets/ldp/game-3.png": "tkmL",
	"./assets/ldp/game-4.png": "HMzI",
	"./assets/ldp/game-5.png": "Fvts",
	"./assets/ldp/h5btn.gif": "o0+6",
	"./assets/ldp/login.gif": "oIuv",
	"./assets/ldp/regist.gif": "4hx1",
	"./assets/logo.png": "7Otq",
	"./assets/new-sport/bgi-email.png": "gjd6",
	"./assets/new-sport/bgi-form-h5.png": "D4no",
	"./assets/new-sport/bgi-gorm.png": "Hqku",
	"./assets/new-sport/bgi-h5.jpg": "lX2g",
	"./assets/new-sport/bgi-pc.jpg": "mill",
	"./assets/new-sport/bgi-phone.png": "MT4f",
	"./assets/new-sport/bgi-pwd.png": "XtyZ",
	"./assets/new-sport/bgi-user.png": "U9+g",
	"./assets/new-sport/btn-login.gif": "nCw3",
	"./assets/new-sport/btn-register.gif": "uSEO",
	"./assets/new-sport/icon-1.png": "aoXN",
	"./assets/new-sport/icon-2.png": "I7SW",
	"./assets/new-sport/icon-3.png": "4rPr",
	"./assets/new-sport/icon-4.png": "4WFQ",
	"./assets/new-sport/icon-5.png": "W/02",
	"./assets/new-sport/icon-6.png": "xHG/",
	"./assets/new-sport/icon-close.png": "XX6M",
	"./assets/new-sport/icon-fb.png": "K/K4",
	"./assets/new-sport/icon-l.png": "nAI9",
	"./assets/new-sport/icon-login-a.png": "RPx5",
	"./assets/new-sport/icon-login-n.png": "mjuq",
	"./assets/new-sport/icon-r.png": "MgXx",
	"./assets/new-sport/icon-reg-a.png": "KSLH",
	"./assets/new-sport/icon-reg-n.png": "7vgK",
	"./assets/new-sport/icon-tg.png": "AW7k",
	"./assets/new-sport/main-register.gif": "WBJp",
	"./assets/new-sport/success-login-h5.png": "GeVb",
	"./assets/new-sport/success-login.png": "xZCB",
	"./assets/new-sport/success-reg-h5.png": "upB4",
	"./assets/new-sport/success-reg.png": "Yl8G",
	"./assets/road/bgi-btn-active.png": "XVwg",
	"./assets/road/bgi-btn-normal.png": "uBzu",
	"./assets/road/bgi-btn-submit.png": "qwLw",
	"./assets/road/bgi-dialog-h5.png": "+Jrp",
	"./assets/road/bgi-dialog-pc.png": "WDcB",
	"./assets/road/bgi-h5.jpg": "/z0R",
	"./assets/road/bgi-input.png": "0qZ8",
	"./assets/road/bgi-message.png": "A8OC",
	"./assets/road/bgi-pc.jpg": "ss9A",
	"./assets/road/icon-email.png": "rfCd",
	"./assets/road/icon-password.png": "//NM",
	"./assets/road/icon-phone.png": "DVW3",
	"./assets/road/icon-success.png": "d19U",
	"./assets/road/icon-username.png": "/+Vt",
	"./assets/road/logo.png": "ph1m",
	"./assets/road/title.png": "z8t6",
	"./assets/sport/bgi-dialog.png": "HRUs",
	"./assets/sport/bgi-form.png": "Op1d",
	"./assets/sport/bgi-h5.jpg": "+7KZ",
	"./assets/sport/bgi-input.png": "dsok",
	"./assets/sport/bgi-pc.jpg": "H3Vr",
	"./assets/sport/btn-login.png": "WdUv",
	"./assets/sport/btn-register.png": "xgbq",
	"./assets/sport/icon-email.png": "Vd+V",
	"./assets/sport/icon-fb.png": "NvwI",
	"./assets/sport/icon-password.png": "F0Xg",
	"./assets/sport/icon-phone.png": "LyPF",
	"./assets/sport/icon-tg.png": "btIk",
	"./assets/sport/icon-username.png": "4Wei",
	"./assets/sport/loading.gif": "EQQn",
	"./assets/sport/tag-login.png": "Us2E",
	"./assets/sport/tag-regist.png": "k40h",
	"./assets/sport/title.png": "ve7A",
	"./assets/sport3/bgi-dialog.png": "Tgtq",
	"./assets/sport3/bgi-form.png": "Z0Zo",
	"./assets/sport3/bgi-h5.jpg": "Uitw",
	"./assets/sport3/bgi-input.png": "ueap",
	"./assets/sport3/bgi-pc.jpg": "T8Oo",
	"./assets/sport3/btn-login.png": "vX9w",
	"./assets/sport3/btn-register.png": "D5Rc",
	"./assets/sport3/icon-email.png": "E9ek",
	"./assets/sport3/icon-fb.png": "p07M",
	"./assets/sport3/icon-password.png": "kNUW",
	"./assets/sport3/icon-phone.png": "JLde",
	"./assets/sport3/icon-tg.png": "/dBP",
	"./assets/sport3/icon-username.png": "MRBe",
	"./assets/sport3/loading.gif": "vOM9",
	"./assets/sport3/tag-login.png": "2s1T",
	"./assets/sport3/tag-regist.png": "rz3M",
	"./assets/sport3/title.png": "+eic",
	"./assets/sport4/bgi-dialog.png": "bcPw",
	"./assets/sport4/bgi-form.png": "NbZR",
	"./assets/sport4/bgi-h5.jpg": "1SK2",
	"./assets/sport4/bgi-input.png": "I9Zm",
	"./assets/sport4/bgi-pc.jpg": "wqC/",
	"./assets/sport4/btn-login.png": "o6Ig",
	"./assets/sport4/btn-register.png": "5yxg",
	"./assets/sport4/icon-email.png": "EpwQ",
	"./assets/sport4/icon-fb.png": "wuG/",
	"./assets/sport4/icon-password.png": "iKUx",
	"./assets/sport4/icon-phone.png": "SueM",
	"./assets/sport4/icon-tg.png": "kdOD",
	"./assets/sport4/icon-username.png": "IoEo",
	"./assets/sport4/loading.gif": "VRls",
	"./assets/sport4/logo.png": "mlOo",
	"./assets/sport4/swiper-1.png": "nY4q",
	"./assets/sport4/swiper-2.png": "9l4U",
	"./assets/sport4/swiper-3.png": "XMi7",
	"./assets/sport4/swiper-4.png": "6WKB",
	"./assets/sport4/tag-login.png": "er09",
	"./assets/sport4/tag-regist.png": "c26H",
	"./assets/sport4/title.png": "RF4A",
	"./assets/sport5/bgi-form-login.png": "7J2L",
	"./assets/sport5/bgi-form.png": "cVph",
	"./assets/sport5/bgi-h5.png": "Hi2X",
	"./assets/sport5/bgi-input.png": "v76d",
	"./assets/sport5/bgi-pc.png": "5ok3",
	"./assets/sport5/btn-login.png": "ZmLu",
	"./assets/sport5/btn-register.png": "6+P1",
	"./assets/sport5/close-dialog.png": "78V8",
	"./assets/sport5/dang-ky-nhan.png": "k1fy",
	"./assets/sport5/facebook.png": "qYMw",
	"./assets/sport5/game-bottom.png": "PgWw",
	"./assets/sport5/login-success-new.png": "G/n9",
	"./assets/sport5/login-success.png": "Ksrj",
	"./assets/sport5/logo-title.png": "p/PV",
	"./assets/sport5/middle-center.png": "1D7e",
	"./assets/sport5/register-success-new.png": "Iuqj",
	"./assets/sport5/register-success.png": "TXb0",
	"./assets/sport5/swiper-1.png": "BvaE",
	"./assets/sport5/swiper-2.png": "ZQ6n",
	"./assets/sport5/swiper-3.png": "R9ss",
	"./assets/sport5/swiper-4.png": "9T50",
	"./assets/sport5/tag-login-active.png": "sLri",
	"./assets/sport5/tag-login.png": "bgwC",
	"./assets/sport5/tag-regist-active.png": "Qb1a",
	"./assets/sport5/tag-regist.png": "GXAM",
	"./assets/sport5/telegram.png": "JhaX",
	"./assets/sport6/arrow.png": "phYH",
	"./assets/sport6/bg-h5.jpg": "YKLF",
	"./assets/sport6/bg.jpg": "XGvb",
	"./assets/sport6/facebook.png": "fBG5",
	"./assets/sport6/form/check.png": "rDxJ",
	"./assets/sport6/form/form-bg.png": "PfoZ",
	"./assets/sport6/form/lock.png": "Ieng",
	"./assets/sport6/form/login-1.png": "QKo1",
	"./assets/sport6/form/login-2.png": "z7zQ",
	"./assets/sport6/form/register-1.png": "cJ7e",
	"./assets/sport6/form/register-2.png": "EhdE",
	"./assets/sport6/form/safe.png": "x23S",
	"./assets/sport6/game-1.png": "Bbd2",
	"./assets/sport6/game-2.png": "49O3",
	"./assets/sport6/game-3.png": "68DE",
	"./assets/sport6/game-4.png": "IuDr",
	"./assets/sport6/game.png": "zb8m",
	"./assets/sport6/icon-1.png": "uKGT",
	"./assets/sport6/icon-2.png": "8sy4",
	"./assets/sport6/icon-3.png": "Jesp",
	"./assets/sport6/icon.png": "ei3M",
	"./assets/sport6/login.gif": "J9/x",
	"./assets/sport6/logo.png": "Boj1",
	"./assets/sport6/regist.gif": "BCH8",
	"./assets/sport6/success.png": "4UBp",
	"./assets/sport6/telegram.png": "0LbC",
	"./assets/sport6/title.png": "hNZi",
	"./assets/sport7/bg-h5.png": "UCoM",
	"./assets/sport7/bg.jpg": "t27e",
	"./assets/sport7/bg.png": "HDIy",
	"./assets/sport7/bgi-dialog.png": "nZyb",
	"./assets/sport7/btn-next.svg": "wh9J",
	"./assets/sport7/btn-prev.svg": "T7j7",
	"./assets/sport7/euro.gif": "1cCA",
	"./assets/sport7/facebook.png": "9m54",
	"./assets/sport7/form-pc/form-bg-1.png": "crsa",
	"./assets/sport7/form-pc/form-bg.png": "5yO/",
	"./assets/sport7/form/form-bg-1.png": "S2ok",
	"./assets/sport7/form/form-bg.png": "vVEq",
	"./assets/sport7/form/icon-code.png": "28ue",
	"./assets/sport7/form/icon-eye.png": "fKtK",
	"./assets/sport7/form/icon-ieye.png": "1GDr",
	"./assets/sport7/form/icon-passwd.png": "D+dY",
	"./assets/sport7/form/icon-phone.png": "0iTC",
	"./assets/sport7/form/icon-user.png": "KnCu",
	"./assets/sport7/form/login-1.png": "LAKf",
	"./assets/sport7/form/login-2.png": "JBiA",
	"./assets/sport7/form/register-1.png": "lmOw",
	"./assets/sport7/form/register-2.png": "u66R",
	"./assets/sport7/game-1.png": "P26U",
	"./assets/sport7/game-2.png": "w9gM",
	"./assets/sport7/game-3.png": "X5D+",
	"./assets/sport7/game-4.png": "M9pG",
	"./assets/sport7/game-5.png": "skq/",
	"./assets/sport7/login.gif": "8Vu/",
	"./assets/sport7/logo.png": "wAE1",
	"./assets/sport7/regist.gif": "aUmv",
	"./assets/sport7/register-success-new.png": "X6H5",
	"./assets/sport7/success.png": "K8Az",
	"./assets/sport7/telegram.png": "dMzM",
	"./assets/sport7/title-pc.png": "KAi6",
	"./assets/sport7/title.png": "kT7F",
	"./assets/svg/email.svg": "ULWC",
	"./assets/svg/mobile.svg": "sxKw",
	"./assets/svg/password.svg": "Jtj/",
	"./assets/svg/user.svg": "fP5l",
	"./assets/telegram.png": "Rplw",
	"./assets/trea/bgi-btn-reg.png": "Hev4",
	"./assets/trea/bgi-dialog.png": "felI",
	"./assets/trea/bgi-form.png": "GruS",
	"./assets/trea/bgi-h5.jpg": "tfNC",
	"./assets/trea/bgi-login-active.png": "tL1v",
	"./assets/trea/bgi-login-btn.png": "dtyl",
	"./assets/trea/bgi-login-normal.png": "iSEt",
	"./assets/trea/bgi-reg-active.png": "z482",
	"./assets/trea/bgi-reg-normal.png": "23CA",
	"./assets/trea/bgi-swiper.png": "Hnog",
	"./assets/trea/bgi.jpg": "wdL5",
	"./assets/trea/captain.png": "F0vm",
	"./assets/trea/icon-close.png": "NwiD",
	"./assets/trea/icon-email.png": "eaIa",
	"./assets/trea/icon-password.png": "b7EA",
	"./assets/trea/icon-phone.png": "TTWp",
	"./assets/trea/icon-user.png": "enPz",
	"./assets/trea/logo.png": "PkpH",
	"./assets/trea/slide1.png": "3twk",
	"./assets/trea/slide2.png": "IkQc",
	"./assets/trea/slide3.png": "IHDB",
	"./assets/trea/slide4.png": "8ux0",
	"./assets/trea/treaure.png": "7cnQ",
	"./assets/year/bgi-btn-a.png": "JGdw",
	"./assets/year/bgi-btn-i.png": "YhpC",
	"./assets/year/bgi-btn-reg.png": "yLrB",
	"./assets/year/bgi-form.png": "GdKx",
	"./assets/year/bgi-input.png": "aCni",
	"./assets/year/bgi-mobile.png": "ioh/",
	"./assets/year/bgi-model.png": "8I8B",
	"./assets/year/bgi-swiper.png": "4CZm",
	"./assets/year/bgi.png": "GEbI",
	"./assets/year/icon-close.png": "CCye",
	"./assets/year/icon-left.png": "Wbap",
	"./assets/year/icon-right.png": "E+R3",
	"./assets/year/logo.png": "Eeky",
	"./assets/year/slide1.png": "OUSe",
	"./assets/year/slide2.png": "+gDf",
	"./assets/year/slide3.png": "K8hi",
	"./assets/year/slide4.png": "SDWD",
	"./assets/year/slide5.png": "O5c6",
	"./assets/year/slide6.png": "GV1Y",
	"./assets/year/slide7.png": "UL19",
	"./assets/year/slide8.png": "PR/U",
	"./assets/year/title.png": "FM5v",
	"./components/Football": "z0Jt",
	"./components/Football.vue": "z0Jt",
	"./components/Jump": "P2fZ",
	"./components/Jump.vue": "P2fZ",
	"./components/Ldp": "noY1",
	"./components/Ldp.vue": "noY1",
	"./components/NewSport": "ILcB",
	"./components/NewSport.vue": "ILcB",
	"./components/NewYear": "T2U0",
	"./components/NewYear.vue": "T2U0",
	"./components/Road": "6+76",
	"./components/Road.vue": "6+76",
	"./components/Sport": "fyOp",
	"./components/Sport.vue": "fyOp",
	"./components/Sport3": "ABbn",
	"./components/Sport3.vue": "ABbn",
	"./components/Sport4": "+Zqk",
	"./components/Sport4.vue": "+Zqk",
	"./components/Sport5": "l/Hs",
	"./components/Sport5.vue": "l/Hs",
	"./components/Sport6": "moTj",
	"./components/Sport6.vue": "moTj",
	"./components/Sport7": "EN0q",
	"./components/Sport7.vue": "EN0q",
	"./components/Sport8": "wo6U",
	"./components/Sport8.vue": "wo6U",
	"./components/Treasure": "OhtY",
	"./components/Treasure.vue": "OhtY",
	"./components/common": "vAZe",
	"./components/common/": "vAZe",
	"./components/common/SysContact": "1AmT",
	"./components/common/SysContact.vue": "1AmT",
	"./components/common/SysDialog": "Qchh",
	"./components/common/SysDialog.vue": "Qchh",
	"./components/common/SysLoading": "UE2W",
	"./components/common/SysLoading.vue": "UE2W",
	"./components/common/SysSwiper": "m177",
	"./components/common/SysSwiper.vue": "m177",
	"./components/common/SysSwiperPc": "vEam",
	"./components/common/SysSwiperPc.vue": "vEam",
	"./components/common/captcha": "u8oE",
	"./components/common/captcha.vue": "u8oE",
	"./components/common/index": "vAZe",
	"./components/common/index.js": "vAZe",
	"./main": "NHnr",
	"./main.js": "NHnr",
	"./mixins/captcha": "awAM",
	"./mixins/captcha.js": "awAM",
	"./utils/api": "VsUZ",
	"./utils/api.js": "VsUZ",
	"./utils/constant": "8e4C",
	"./utils/constant.js": "8e4C",
	"./utils/plugin": "0xks",
	"./utils/plugin.js": "0xks",
	"./utils/request": "vLgD",
	"./utils/request.js": "vLgD",
	"./utils/tools": "GKmE",
	"./utils/tools.js": "GKmE",
	"./utils/util": "oFuF",
	"./utils/util.js": "oFuF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xX3y";


//////////////////
// WEBPACK FOOTER
// ./src ^.*$
// module id = xX3y
// module chunks = 0